














import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IWizardPage, IWizardContent } from "../../../../../domain/format";
import { DocumentEditableMixin } from "../../mixins";
import { WizardContent } from "./contents";

@Component({
  components: {
    WizardContent,
  },
})
export default class DocumentPageEditor extends Mixins(DocumentEditableMixin) {
  $refs!: {
    editor: HTMLDivElement,
  };

  @Prop()
  page: IWizardPage;

  @Prop({ default: 1 })
  scale: number;

  get formatContents(): IWizardContent[] {
    return this.page
      ? this.page.contents
      : [];
  }

  get editorStyle() {
    return {
      fontSize: this.page.attributes.fontSize ? `calc(${this.page.attributes.fontSize}*${this.scale})` : undefined,
    };
  }

  @Watch("page")
  onFormatPageUpdated(newValue: IWizardPage) {
    this.$refs.editor.scrollTop = 0;
  }
}
